export default __webpack_public_path__ + "static/media/practice_img.313adcc2.png";